import React from 'react'
import { FormattedMessage } from 'react-intl'

export default function (values: any) {
  const errors: any = {}
  const requiredFields = ['username', 'password']
  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = <FormattedMessage id='form.required' />
    }
  })

  return errors
}
